import React from 'react';
import styled, { css } from 'styled-components';

import colors from '../../../vars/colors';

export const CSOverlayWrapper = styled.div`
    .overlay {
        position: fixed;
        overflow-y: scroll;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        opacity: 0;
        z-index: 5;
        pointer-events: 0;
        background: ${colors['white-two']};
        transition: opacity 300ms ease-in-out;
        border-bottom: solid 6px ${colors['lipstick']};
        &.entering {
            opacity: 1;
        }
        &.entered {
            opacity: 1;
            pointer-events: all;
        }
        &.exiting {
            opacity: 0;
        }
    }
    .cityAndState {
        text-transform: uppercase;
        a {
            transition: color 300ms ease-in;
        }        
        .city,
        .state {
            a {
                text-decoration: none;
            }
        }        
        .city {
            font-family: 'OneDotExt', sans-serif;
            font-size: 40px;
            font-weight: bold;
            line-height: 1.35;
            text-align: left;
            a {
                color: ${colors['grey-brown']};    
            }            
            &.current {
                a {
                    color: ${colors['lipstick']};
                }                
            }
        }
        .state {
            font-family: 'OneDot', sans-serif;
            font-size: 25px;
            font-weight: bold;
            line-height: 2.16;
            letter-spacing: 2.9px;            
            a {
                color: black;
            }
        }
        &:hover {
            .city {
                a {
                    color: ${colors['peacock-blue']};    
                }            
            }
        }
    }
    .allTownsLabel {
        font-family: 'OneDot', sans-serif;
        font-size: 40px;
        color: ${colors['peacock-blue']};
        text-transform: uppercase;
        font-weight: bold;
        margin-bottom: 50px;
    }
`;



// WEBPACK FOOTER //
// ./src/components/modules/CSOverlay/styled-components.js